var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9355 1.00029H15.1059C15.566 0.992282 16.0131 1.15079 16.3622 1.44574C16.7114 1.74068 16.9383 2.15152 17 2.60026V8.20016C16.9383 8.6489 16.7114 9.05974 16.3622 9.35468C16.0131 9.64962 15.566 9.80814 15.1059 9.80013H12.9355M7.24521 11.4001V14.6C7.24521 15.2366 7.50215 15.847 7.95949 16.2971C8.41684 16.7471 9.03713 17 9.68391 17L12.9355 9.80013V1.00029H3.76601C3.37392 0.995927 2.99345 1.13116 2.69468 1.38108C2.39592 1.63099 2.199 1.97875 2.14021 2.36026L1.01841 9.56013C0.983043 9.78944 0.998759 10.0236 1.06447 10.2463C1.13018 10.4691 1.24431 10.6751 1.39896 10.8501C1.55361 11.0251 1.74508 11.165 1.9601 11.2599C2.17511 11.3549 2.40854 11.4027 2.64421 11.4001H7.24521Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/DISLIKE.3ddf23369fa4ba529d416eb28c2b7532.svg";
export { ForwardRef as ReactComponent };